<img src="assets/flags/{{country.toLowerCase()}}.jpg" [alt]="alt || ''" *ngIf="country" class="flag-icon {{imageClass}}" width="18"
     height="14" loading="lazy">
